"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _Tooltip = _interopRequireDefault(require("../../Tooltip/Tooltip"));

var _icons = require("../../../assets/icons");

var _HeaderCell = require("./HeaderCell.styles");

var _elements = require("../../../styles/elements");

var Sorter = (0, _base["default"])("div", {
  target: "eanfd7q0",
  label: "Sorter"
})(_HeaderCell.styles.sorter, ";");

var HeaderCell = function HeaderCell(_ref) {
  var children = _ref.children,
      canSort = _ref.canSort,
      isSorted = _ref.isSorted,
      isSortedDesc = _ref.isSortedDesc,
      className = _ref.className,
      disabled = _ref.disabled,
      disabledHint = _ref.disabledHint;
  var handleCLickIcons = (0, _react.useCallback)(function (e) {
    if (disabled) {
      // Don't propagate click event to its parent when it's disabled
      e.stopPropagation();
    }
  }, [disabled]);

  if (canSort) {
    // Need to show sorter icons
    return (0, _jsxRuntime.jsx)(_Tooltip["default"], {
      title: disabled ? disabledHint : undefined,
      position: "top-start",
      maxWidth: 300,
      children: (0, _jsxRuntime.jsxs)("button", {
        type: "button",
        css: [_elements.button.styles.preflight, _HeaderCell.styles.sorterBtn, disabled && _HeaderCell.styles.diabledBtn, process.env.NODE_ENV === "production" ? "" : ";label:HeaderCell;"],
        className: (0, _clsx["default"])('grui', className),
        disabled: disabled,
        children: [children, (0, _jsxRuntime.jsxs)(Sorter, {
          isSorted: isSorted,
          isSortedDesc: isSortedDesc,
          onClick: handleCLickIcons,
          children: [(0, _jsxRuntime.jsx)("span", {
            children: (0, _jsxRuntime.jsx)(_icons.ChevronRight, {})
          }), (0, _jsxRuntime.jsx)("span", {
            children: (0, _jsxRuntime.jsx)(_icons.ChevronRight, {})
          })]
        })]
      })
    });
  }

  return children;
};

HeaderCell.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  className: _propTypes.string,
  canSort: _propTypes.bool,
  disabled: _propTypes.bool
};
HeaderCell.defaultProps = {
  children: undefined,
  className: undefined,
  canSort: false,
  disabled: false
};
var _default = HeaderCell;
exports["default"] = _default;
//# sourceMappingURL=HeaderCell.js.map